import { useState, useEffect } from 'react';
import { Plus, Zap } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "src/@/components/ui/tabs";
import { Button } from 'src/@/components/ui/button';
import { Card, CardContent, CardHeader } from 'src/@/components/ui/card';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import Iconify from 'src/components/Iconify';
import ModalAlerta from 'src/components/modal/ModalAlerta';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import EmptyContentGhost from 'src/components/EmptyContentGhost';

// actions
import v2_actionDeletarPipeline from 'src/actions/v2/crm/v2_actionDeletarPipeline';
import v2_actionConfigCrm from 'src/actions/v2/crm/v2_actionConfigCrm';
import v2_actionAddCrmSource from 'src/actions/v2/crm/v2_actionAddCrmSource';
import v2_actionEditarCrmSource from 'src/actions/v2/crm/v2_actionEditarCrmSource';
import v2_actionDeletarCrmSource from 'src/actions/v2/crm/v2_actionDeletarCrmSource';
import v2_actionEditCrmReason from 'src/actions/v2/crm/v2_actionEditCrmReason';
import v2_actionAddCrmReason from 'src/actions/v2/crm/v2_actionAddCrmReason';
import v2_actionListScoringDefinitions from 'src/actions/v2/crm/v2_actionListScoringDefinitions';
import v2_actionAddScoringDefinition from 'src/actions/v2/crm/v2_actionAddScoringDefinition';
import v2_actionEditScoringDefinition from 'src/actions/v2/crm/v2_actionEditScoringDefinition';
import v2_actionDeleteScoringDefinition from 'src/actions/v2/crm/v2_actionDeleteScoringDefinition';

// local components
import PipileneItem from './PipileneItem';
import DrawerNovoFunil from './DrawerNovoFunil';
import TableReasons from './TableReasons';
import TableOrigins from './TableOrigins';
import ModalReasons from './ModalReasons';
import ModalOrigins from './ModalOrigins';
import TableScoring from './TableScoring';
import ModalScoring from './ModalScoring';
import TabCustomFields from './TabCustomFields';
import TabLayoutConfig from './TabLayoutConfig';

// design system
import { FUNIL_COMPONENT_DESIGN } from './FunilComponent.design';

export default function FunilComponent({ cliente, user }) {
  const [modalAlerta, setModalAlerta] = useState(false);
  const [openDrawerNovoFunil, setOpenDrawerNovoFunil] = useState(false);
  const [configCrm, setConfigCrm] = useState(null);
  const [openModalConfirmacaoExclusao, setOpenModalConfirmacaoExclusao] = useState(false);

  const [pipeline, setPipeline] = useState(null);
  const [pipelineId, setPipelineId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [motivos, setMotivos] = useState([]);
  const [origens, setOrigens] = useState([]);

  //reasons
  const [openConfirmReasonDelete, setOpenConfirmReasonDelete] = useState(false);
  const [openDialogReason, setOpenDialogReason] = useState(false);
  const [idReason, setIdReason] = useState(null);
  const [action, setAction] = useState(null);
  const [nameReason, setNameReason] = useState(null);

  //origins
  const [openConfirmOriginDelete, setOpenConfirmOriginDelete] = useState(false);
  const [openDialogOrigin, setOpenDialogOrigin] = useState(false);
  const [idOrigin, setIdOrigin] = useState(null);
  const [actionOrigin, setActionOrigin] = useState(null);
  const [nameOrigin, setNameOrigin] = useState(null);
  const [descricaoOrigin, setDescricaoOrigin] = useState(null);
  const [ativoOrigin, setAtivoOrigin] = useState(true);

  //scoring
  const [scoringDefs, setScoringDefs] = useState([]);
  const [openConfirmScoringDelete, setOpenConfirmScoringDelete] = useState(false);
  const [openDialogScoring, setOpenDialogScoring] = useState(false);
  const [idScoring, setIdScoring] = useState(null);
  const [actionScoring, setActionScoring] = useState(null);
  const [nameScoring, setNameScoring] = useState('');
  const [typeScoring, setTypeScoring] = useState('credit');
  const [pointsScoring, setPointsScoring] = useState('');
  const [statusScoring, setStatusScoring] = useState('true');


  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.status === 200) {
        if (querys) {
          console.log('setando data')
          setConfigCrm(result.data?.data);
        } else {
          setMotivos(result.data?.data?.motivos)
          setOrigens(
            (result.data?.data?.origens || []).filter(origem => origem.cliente_id)
          )
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  async function handleEditReason() {
    try {
      let data = {
        scope: {
          name: nameReason
        }
      }
      await v2_actionEditCrmReason(idReason, data);
      buscarConfigCrm(null)
      setOpenDialogReason(false);
      setAction(null);
      setNameReason('');
    } catch (error) {
      setOpenConfirmReasonDelete(false);
      console.log(error);
    }
  }
  async function handleDelete() {
    try {
      let data = {
        scope: {
          deleted: true
        }
      }
      await v2_actionEditCrmReason(idReason, data);
      buscarConfigCrm(null);
      setOpenConfirmReasonDelete(false);
      setAction(null);
      setNameReason('');
    } catch (error) {
      setOpenConfirmReasonDelete(false);
      console.log(error);
    }
  }

  async function handleDeletePipeline() {
    try {
      let data = {
        scope: {
          deleted: true
        }
      }
      await v2_actionDeletarPipeline(pipelineId);
      let querys = `?all=1`
      buscarConfigCrm(querys)
      setOpenModalConfirmacaoExclusao(false);
      setAction(null);
      setPipelineId(null);
    } catch (error) {
      setOpenModalConfirmacaoExclusao(false);
      console.log(error);
    }
  }

  async function handleCreateReasonLost() {
    try {
      let data = {
        name: nameReason
      }
      await v2_actionAddCrmReason(cliente._id, data);
      buscarConfigCrm(null);
      setOpenDialogReason(false);
      setNameReason('');
    } catch (error) {
      console.log(error);
    }
  }

  // Funções para gerenciar origens de contato
  async function handleCreateOrigin() {
    try {
      let data = {
        scope: {
          name: nameOrigin,
          description: descricaoOrigin,
          active: ativoOrigin
        }
      }
      await v2_actionAddCrmSource(cliente._id, data);
      buscarConfigCrm(null);
      setOpenDialogOrigin(false);
      setNameOrigin('');
      setDescricaoOrigin('');
      setAtivoOrigin(true);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleEditOrigin() {
    try {
      let data = {
        scope: {
          name: nameOrigin,
          description: descricaoOrigin,
          active: ativoOrigin
        }
      }
      await v2_actionEditarCrmSource(idOrigin, data);
      buscarConfigCrm(null);
      setOpenDialogOrigin(false);
      setActionOrigin(null);
      setNameOrigin('');
      setDescricaoOrigin('');
      setAtivoOrigin(true);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleDeleteOrigin() {
    try {
      await v2_actionDeletarCrmSource(idOrigin);
      buscarConfigCrm(null);
      setOpenConfirmOriginDelete(false);
      setActionOrigin(null);
      setNameOrigin('');
      setDescricaoOrigin('');
      setAtivoOrigin(true);
    } catch (error) {
      setOpenConfirmOriginDelete(false);
      console.log(error);
    }
  }

  // Scoring CRUD
  async function buscarScoringDefs() {
    try {
      const result = await v2_actionListScoringDefinitions(cliente._id);
      if (result.status === 200) {
        setScoringDefs(result.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCreateScoring() {
    try {
      let data = {
        name: nameScoring,
        type: typeScoring,
        points: Number(pointsScoring),
        status: statusScoring
      }
      await v2_actionAddScoringDefinition(cliente._id, data);
      buscarScoringDefs();
      setOpenDialogScoring(false);
      resetScoringFields();
    } catch (error) {
      console.log(error);
    }
  }

  async function handleEditScoring() {
    try {
      let data = {
        scope: {
          name: nameScoring,
          type: typeScoring,
          points: Number(pointsScoring),
          status: statusScoring
        }
      }
      await v2_actionEditScoringDefinition(idScoring, data);
      buscarScoringDefs();
      setOpenDialogScoring(false);
      resetScoringFields();
    } catch (error) {
      console.log(error);
    }
  }

  async function handleDeleteScoring() {
    try {
      await v2_actionDeleteScoringDefinition(idScoring);
      buscarScoringDefs();
      setOpenConfirmScoringDelete(false);
      resetScoringFields();
    } catch (error) {
      setOpenConfirmScoringDelete(false);
      console.log(error);
    }
  }

  function resetScoringFields() {
    setActionScoring(null);
    setNameScoring('');
    setTypeScoring('credit');
    setPointsScoring('');
    setStatusScoring('true');
    setIdScoring(null);
  }

  useEffect(() => {
    let querys = `?all=1`
    buscarConfigCrm(querys)
    buscarConfigCrm(null)
    buscarScoringDefs()
  }, [])

  return (
    <>
      <ModalAlerta
        open={modalAlerta}
        onClose={() => setModalAlerta(false)}
        mensagem={'Não é possivel editar resposta rapida do tipo arquivo ou audio, exclua e crie uma nova resposta rápida'}
      />

      <ModalConfimacao
        open={openModalConfirmacaoExclusao}
        onClose={() => setOpenModalConfirmacaoExclusao(false)}
        onConfirm={() => handleDeletePipeline()}
        loadingFinalizar={null}
        mensagem={'Deseja mesmo excluir esse funil?'}
      />

      <ModalConfimacao
        open={openConfirmReasonDelete}
        onClose={() => {
          setOpenConfirmReasonDelete(false);
        }}
        onConfirm={handleDelete}
        loadingFinalizar={loading}
        mensagem={'Deseja mesmo excluir?'}
      />

      <DrawerNovoFunil
        open={openDrawerNovoFunil}
        onClose={() => {
          setOpenDrawerNovoFunil(false);
          setIsEdit(false)
        }}
        onCallback={() => {
          let querys = `?all=1`
          buscarConfigCrm(querys)
          setOpenDrawerNovoFunil(false)
        }}
        user={user}
        cliente={cliente}
        isEdit={isEdit}
        pipeline={pipeline}
        pipelineId={pipeline?._id}
      />

      <ModalReasons
        open={openDialogReason}
        action={action}
        nome={nameReason}
        changeNome={(e) => {
          setNameReason(e.target.value)
        }}
        onSubmit={action === "Criar" ? handleCreateReasonLost : handleEditReason}
        onClose={() => {
          setOpenDialogReason(false);
          setNameReason('');
          setIdReason(null);
        }}
      />

      <ModalConfimacao
        open={openConfirmOriginDelete}
        onClose={() => {
          setOpenConfirmOriginDelete(false);
        }}
        onConfirm={handleDeleteOrigin}
        loadingFinalizar={loading}
        mensagem={'Deseja mesmo excluir esta origem de contato?'}
      />

      <ModalOrigins
        open={openDialogOrigin}
        action={actionOrigin}
        nome={nameOrigin}
        descricao={descricaoOrigin}
        ativo={ativoOrigin}
        changeNome={(e) => {
          setNameOrigin(e.target.value)
        }}
        changeDescricao={(e) => {
          setDescricaoOrigin(e.target.value)
        }}
        changeAtivo={(checked) => {
          setAtivoOrigin(checked)
        }}
        onSubmit={actionOrigin === "Criar" ? handleCreateOrigin : handleEditOrigin}
        onClose={() => {
          setOpenDialogOrigin(false);
          setNameOrigin('');
          setDescricaoOrigin('');
          setAtivoOrigin(true);
          setIdOrigin(null);
        }}
      />

      <ModalConfimacao
        open={openConfirmScoringDelete}
        onClose={() => {
          setOpenConfirmScoringDelete(false);
        }}
        onConfirm={handleDeleteScoring}
        loadingFinalizar={loading}
        mensagem={'Deseja mesmo excluir esta regra de score?'}
      />

      <ModalScoring
        open={openDialogScoring}
        action={actionScoring}
        nome={nameScoring}
        changeNome={(e) => setNameScoring(e.target.value)}
        tipo={typeScoring}
        changeTipo={(value) => setTypeScoring(value)}
        pontos={pointsScoring}
        changePontos={(e) => setPointsScoring(e.target.value)}
        status={statusScoring}
        changeStatus={(value) => setStatusScoring(value)}
        onSubmit={actionScoring === "Criar" ? handleCreateScoring : handleEditScoring}
        onClose={() => {
          setOpenDialogScoring(false);
          resetScoringFields();
        }}
      />

      <div className={FUNIL_COMPONENT_DESIGN.page.container}>
        {/* Header */}
        <div className={FUNIL_COMPONENT_DESIGN.page.header.container}>
          <div>
            <h1 className={FUNIL_COMPONENT_DESIGN.page.header.title}>Funil</h1>
            <p className={FUNIL_COMPONENT_DESIGN.page.header.subtitle}>
              Gerencie os funis de vendas da sua empresa. Configure pipelines, etapas e status.
            </p>
          </div>
          <button
            onClick={() => {
              setOpenDrawerNovoFunil(true);
              setAction('Criar')
            }}
            className={FUNIL_COMPONENT_DESIGN.page.actionButton}
          >
            <Plus size={18} />
            <span>Criar Funil</span>
          </button>
        </div>

        <Tabs defaultValue="kanban" className="w-full">
          <TabsList className={FUNIL_COMPONENT_DESIGN.tabs.list}>
            <TabsTrigger className={FUNIL_COMPONENT_DESIGN.tabs.trigger} value="kanban">Kanban</TabsTrigger>
            <TabsTrigger className={FUNIL_COMPONENT_DESIGN.tabs.trigger} value="perdas">Motivos de perda</TabsTrigger>
            <TabsTrigger className={FUNIL_COMPONENT_DESIGN.tabs.trigger} value="origens">Origens de Contato</TabsTrigger>
            {/* <TabsTrigger className={FUNIL_COMPONENT_DESIGN.tabs.trigger} value="score">Score</TabsTrigger> */}
            <TabsTrigger className={FUNIL_COMPONENT_DESIGN.tabs.trigger} value="campos">Campos Personalizados</TabsTrigger>
            <TabsTrigger className={FUNIL_COMPONENT_DESIGN.tabs.trigger} value="layout">Layout do Card</TabsTrigger>
          </TabsList>

          <TabsContent value="kanban" className="mt-0">
            <ScrollArea className="h-[75vh]">
              {configCrm?.all_pipelines.length === 0 ? (
                <div className={FUNIL_COMPONENT_DESIGN.emptyState.container}>
                  <div className={FUNIL_COMPONENT_DESIGN.emptyState.iconBox}>
                    <Zap size={32} />
                  </div>
                  <h3 className={FUNIL_COMPONENT_DESIGN.emptyState.title}>Nenhum funil cadastrado</h3>
                  <p className={FUNIL_COMPONENT_DESIGN.emptyState.description}>
                    Você ainda não possui nenhum funil de vendas configurado.
                  </p>
                </div>
              ) : (
                <div className="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4">
                  {configCrm?.all_pipelines?.map((item, index) => (
                    <PipileneItem
                      key={item._id || index}
                      user={user}
                      onDelete={item => {
                        setPipelineId(item._id)
                        setOpenModalConfirmacaoExclusao(true)
                      }}
                      onEdit={(item) => {
                        setPipeline(item)
                        setOpenDrawerNovoFunil(true);
                        setIsEdit(true)
                      }}
                      cliente={cliente}
                      pipelines={configCrm?.all_pipelines}
                      index={index}
                      item={item}
                      onCallback={() => {
                        let querys = `?all=1`;
                        buscarConfigCrm(querys)
                      }}
                    />
                  ))}
                </div>
              )}
            </ScrollArea>
          </TabsContent>

          <TabsContent value="perdas" className="mt-0">
            <ScrollArea className="h-[75vh]">
              <div className="w-2/4">
                <Card className="mt-4 border border-gray-100 shadow-sm">
                  <CardHeader className="py-4 border-b border-dashed border-gray-200">
                    <div className='flex flex-row justify-between items-center'>
                      <h2 className="text-lg font-semibold text-gray-900">Motivos de perda</h2>
                      <button
                        className="flex items-center gap-2 px-3 py-1.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-medium rounded-lg transition-colors"
                        onClick={() => {
                          setOpenDialogReason(true);
                          setAction('Criar')
                        }}
                      >
                        <Plus size={14} />
                        Criar
                      </button>
                    </div>
                  </CardHeader>
                  <CardContent className="p-0">
                    {motivos?.length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-12 text-center">
                        <p className='text-sm text-gray-400'>Nenhum motivo foi cadastrado</p>
                      </div>
                    ) : (
                      <TableReasons
                        data={motivos}
                        onSet={value => setIdReason(value)}
                        onConfirm={value => handleDelete(value)}
                        onDelete={row => {
                          setIdReason(row._id);
                          setOpenConfirmReasonDelete(true);
                        }}
                        onEdit={row => {
                          setOpenDialogReason(true)
                          setAction('Editar')
                          setIdReason(row._id);
                          setNameReason(row.name);
                        }}
                      />
                    )}
                  </CardContent>
                </Card>
              </div>
            </ScrollArea>
          </TabsContent>

          <TabsContent value="origens" className="mt-0">
            <ScrollArea className="h-[75vh]">
              <div className="w-2/4">
                <Card className="mt-4 border border-gray-100 shadow-sm">
                  <CardHeader className="py-4 border-b border-dashed border-gray-200">
                    <div className='flex flex-row justify-between items-center'>
                      <h2 className="text-lg font-semibold text-gray-900">Origens de Contato</h2>
                      <button
                        className="flex items-center gap-2 px-3 py-1.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-medium rounded-lg transition-colors"
                        onClick={() => {
                          setOpenDialogOrigin(true);
                          setActionOrigin('Criar')
                        }}
                      >
                        <Plus size={14} />
                        Criar
                      </button>
                    </div>
                  </CardHeader>
                  <CardContent className="p-0">
                    {origens?.length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-12 text-center">
                        <p className='text-sm text-gray-400'>Nenhuma origem foi cadastrada</p>
                      </div>
                    ) : (
                      <TableOrigins
                        data={origens}
                        onEdit={row => {
                          setOpenDialogOrigin(true)
                          setActionOrigin('Editar')
                          setIdOrigin(row._id);
                          setNameOrigin(row.name);
                          setDescricaoOrigin(row.description);
                          setAtivoOrigin(row.active);
                        }}
                        onDelete={row => {
                          setIdOrigin(row._id);
                          setOpenConfirmOriginDelete(true);
                        }}
                      />
                    )}
                  </CardContent>
                </Card>
              </div>
            </ScrollArea>
          </TabsContent>

          <TabsContent value="score" className="mt-0">
            <ScrollArea className="h-[75vh]">
              <div className="w-2/4">
                <Card className="mt-4 border border-gray-100 shadow-sm">
                  <CardHeader className="py-4 border-b border-dashed border-gray-200">
                    <div className='flex flex-row justify-between items-center'>
                      <h2 className="text-lg font-semibold text-gray-900">Regras de Score</h2>
                      <button
                        className="flex items-center gap-2 px-3 py-1.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-medium rounded-lg transition-colors"
                        onClick={() => {
                          setOpenDialogScoring(true);
                          setActionScoring('Criar')
                        }}
                      >
                        <Plus size={14} />
                        Criar
                      </button>
                    </div>
                  </CardHeader>
                  <CardContent className="p-0">
                    {scoringDefs?.length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-12 text-center">
                        <p className='text-sm text-gray-400'>Nenhuma regra de score foi cadastrada</p>
                      </div>
                    ) : (
                      <TableScoring
                        data={scoringDefs}
                        onEdit={row => {
                          setOpenDialogScoring(true)
                          setActionScoring('Editar')
                          setIdScoring(row._id);
                          setNameScoring(row.name);
                          setTypeScoring(row.type);
                          setPointsScoring(row.points);
                          setStatusScoring(row.status);
                        }}
                        onDelete={row => {
                          setIdScoring(row._id);
                          setOpenConfirmScoringDelete(true);
                        }}
                      />
                    )}
                  </CardContent>
                </Card>
              </div>
            </ScrollArea>
          </TabsContent>

          <TabsContent value="campos" className="mt-0">
            <ScrollArea className="h-[75vh]">
              <TabCustomFields
                cliente={cliente}
                pipelines={configCrm?.all_pipelines || []}
              />
            </ScrollArea>
          </TabsContent>

          <TabsContent value="layout" className="mt-0">
            <ScrollArea className="h-[75vh]">
              <TabLayoutConfig cliente={cliente} />
            </ScrollArea>
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
}
